import dayjs from 'dayjs';

export const careerOptions = [
  '신입 ~ 1년',
  '2년',
  '3년',
  '4년',
  '5년',
  '6년',
  '7년',
  '8년',
  '9년',
  '10년',
  '10년 초과',
];

export const educationOptios = [
  '고등학교 졸업',
  '전문대(2,3년제) 졸업',
  '대학교(4년제) 졸업',
  '대학원 이상 졸업',
];
